var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 575.975 448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eyeIcon",
    d: "M160,256A128,128,0,1,1,288,384,127.99,127.99,0,0,1,160,256Zm128,80a80,80,0,0,0,0-160h-2.9a39.836,39.836,0,0,1,2.9,16,64.059,64.059,0,0,1-64,64,39.835,39.835,0,0,1-16-2.9v2c0,45.1,35.8,80.9,80,80.9ZM95.42,112.6C142.5,68.84,207.2,32,288,32s145.5,36.84,192.6,80.6c46.8,43.4,78.1,94.5,92.9,131.1a31.8,31.8,0,0,1,0,24.6c-14.8,35.7-46.1,86.8-92.9,131.1C433.5,443.2,368.8,480,288,480S142.5,443.2,95.42,399.4C48.62,355.1,17.34,304,2.461,268.3a31.966,31.966,0,0,1,0-24.6C17.34,207.1,48.62,156,95.42,112.6ZM288,80c-65.2,0-118.8,29.6-159.9,67.7C89.6,183.5,63.02,225.1,49.44,256c13.58,30,40.16,72.5,78.66,108.3C169.2,402.4,222.8,432,288,432s118.8-29.6,159.9-67.7c38.5-35.8,64.2-78.3,78.7-108.3-14.5-30.9-40.2-72.5-78.7-108.3C406.8,109.6,353.2,80,288,80Z",
    transform: "translate(0 -32)",
    fill: "#113252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.8adf4553531e83390bf7fbd0aca55703.svg";
export { ForwardRef as ReactComponent };